import { render, staticRenderFns } from "./PostingPenjualan.vue?vue&type=template&id=6401a3ed&scoped=true&"
import script from "./PostingPenjualan.vue?vue&type=script&lang=js&"
export * from "./PostingPenjualan.vue?vue&type=script&lang=js&"
import style0 from "./PostingPenjualan.vue?vue&type=style&index=0&id=6401a3ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6401a3ed",
  null
  
)

export default component.exports